import React from "react";
import { ColorProps, SpaceProps, TypographyProps } from "styled-system";
import { Box } from "../Box";

interface Props {
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}

export const Span: React.FC<Props & ColorProps & TypographyProps & SpaceProps> = ({ children, dangerouslySetInnerHTML, ...props }) => {
  return (
    <Box as="span" {...props} dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
      {children}
    </Box>
  );
};
